import React, { useState, useEffect } from 'react'
import { FaInstagram, FaFacebookF, FaYoutube, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'
import { trackContact } from '../helpers/analyticsHelper'

const socials = [
    {
        icon: <FaWhatsapp />,
        color: 'hover:bg-[#25D366]',
        label: 'WhatsApp',
        href: 'https://wa.me/916266761336'
    },
    {
        icon: <FaInstagram />,
        color: 'hover:bg-gradient-to-tr hover:from-purple-600 hover:to-pink-500',
        label: 'Instagram',
        href: 'https://instagram.com'
    },
    {
        icon: <FaFacebookF />,
        color: 'hover:bg-blue-600',
        label: 'Facebook',
        href: 'https://facebook.com'
    },
    // {
    //     icon: <FaYoutube />,
    //     color: 'hover:bg-red-600',
    //     label: 'YouTube',
    //     href: 'https://youtube.com'
    // },
    {
        icon: <FaXTwitter />,
        color: 'hover:bg-black',
        label: 'Twitter / X',
        href: 'https://x.com'
    },
    {
        icon: <FaLinkedinIn />,
        color: 'hover:bg-blue-700',
        label: 'LinkedIn',
        href: 'https://linkedin.com'
    }
]

const SocialSidebar = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const windowHeight = window.innerHeight;
            const docHeight = document.documentElement.scrollHeight;

            // Hide if near top (BannerProduct area) - e.g. top 450px
            const isNearTop = scrollTop < 450;

            // Hide if near bottom (Footer area) - e.g. within 350px of bottom
            const isNearBottom = (scrollTop + windowHeight) >= (docHeight - 350);

            if (isNearTop || isNearBottom) {
                setIsVisible(false);
            } else {
                setIsVisible(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        // Call once to set initial state
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className={`fixed right-0 top-1/2 -translate-y-1/2 z-50 flex flex-col gap-2 pr-0 transition-all duration-500 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-full pointer-events-none'}`}>
            {socials.map((social, idx) => (
                <a
                    key={idx}
                    href={social.href}
                    target='_blank'
                    rel='noopener noreferrer'
                    title={social.label}
                    onClick={() => {
                        if (social.label === 'WhatsApp') {
                            trackContact({ method: 'WhatsApp', location: 'Social Sidebar' });
                        }
                    }}
                    className={`group flex items-center justify-end overflow-hidden
                        w-10 hover:w-36 h-10
                        bg-[#1c3026] text-white
                        rounded-l-2xl border border-white/10
                        transition-all duration-300 ease-in-out
                        shadow-lg hover:shadow-xl
                        ${social.color}
                    `}
                    style={{ transitionProperty: 'width, background-color, box-shadow' }}
                >
                    {/* Label — slides in from left on hover */}
                    <span className='text-[10px] font-black uppercase tracking-widest whitespace-nowrap opacity-0 group-hover:opacity-100 pl-3 transition-opacity duration-200 delay-100'>
                        {social.label}
                    </span>
                    {/* Icon — always visible */}
                    <span className='flex items-center justify-center w-10 h-10 shrink-0'>
                        {React.cloneElement(social.icon, { size: 16 })}
                    </span>
                </a>
            ))}
        </div>
    )
}

export default SocialSidebar
